import "./EmployeeStatusSetupStyle.css";

import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_STATUS_SETUP_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { formatDate, sortDDLByLabel, sortData, useNavigateToLogout } from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DDLDataTable } from "../DDLDataTable";
import { EmployeeService } from "../../services/EmployeeService";
import { EmployeeStatusDataTable } from "./Panels/EmployeeStatusDataTable/EmployeeStatusDataTable";
import { EmployeeStatusSetupToolbar } from "./EmployeeStatusSetupToolbar";
import { IAppState } from "../../store/reducers";
import { IEmployeeStatus } from "../../models/Employee/IEmployeeStatus";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { useGetSalaryProfilePermissionData } from "../SalaryProfile";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";


export interface IEmployeeStatusSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "employee-single-data-record";

// const useGetData = (
// 	id: string | undefined,
// 	clientId: string,
// 	navigateToLogout: (path: string) => void
// ) =>
// 	useQuery({
// 		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
// 		queryFn: () => {
// 			return EmployeeService.getEmployeeStatusDataById(
// 				id,
// 				clientId,
// 				navigateToLogout
// 			);
// 		},
// 		refetchOnWindowFocus: false,
// 	});
const useGetEmployeeStatusDataByEmployeeId = (
	employeeId: string | undefined,
	clientId: string,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["get-employee-status-data-by-employee-id", employeeId],
		queryFn: () => {
			return EmployeeService.getEmployeeStatusDataByEmployeeId(
				employeeId,
				clientId,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetEmployeeDDL = (clientId: string) =>
	useQuery({
		queryKey: ["Employee-ddl", clientId],
		queryFn: () => {
			return EmployeeService.getEmployeeDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

const useGetEmployeeStatusDDL = (clientId: string) =>
	useQuery({
		queryKey: ["employee-status-ddl", clientId],
		queryFn: () => {
			return EmployeeService.getGetEmployeeStatusDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

export let employeeStatusInitialData = [
	{
		id: "1",
		employeeStatus: null,
		date: null,
		notes: null,
		rowWithRandomId: true
	},
	{
		id: "2",
		employeeStatus: null,
		date: null,
		notes: null,
		rowWithRandomId: true
	},
	{
		id: "3",
		employeeStatus: null,
		date: null,
		notes: null,
		rowWithRandomId: true
	},
	{
		id: "4",
		employeeStatus: null,
		date: null,
		notes: null,
		rowWithRandomId: true
	},
	{
		id: "5",
		employeeStatus: null,
		date: null,
		notes: null,
		rowWithRandomId: true,
	},
];

export const EmployeeStatusheaderColumns = [
	{
		field: "label",
		headerName: "",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: `employeeStatus`,
		headerName: `Status`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "date",
		headerName: "Date",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		minWidth: "12rem",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: false,
		footer: null,
	},
	{
		field: "notes",
		headerName: "Notes",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "center",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
	},
];

export const EmployeeStatusSetup: React.FC<IEmployeeStatusSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const theme = useTheme();

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const [openDialog, setDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [itemSearch, setItemSearch] = useState("");
	const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);
	const [selectedCard, setSelectedCard] = useState<any>(null);
	const [selectedEmployeeId, setSelectedEmployeeId] = useState<any>(undefined);
	const [EmployeeStatusId, setEmployeeStatusId] = useState<any>(undefined);
	const [employeeStatussList, setEmployeeStatussList] =
		useState<any>(undefined);
	const accountantId = useSelector((state: IAppState) => state.accountant.id);
	const clientId = useSelector((state: IAppState) => state.client.id);
	// const [employeeStatusId, setEmployeeStatusId] = useState<number>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const navigateToLogout = useNavigateToLogout();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);
	const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState("");

	const [employeeStatusUpdatedData, setEmployeeStatusUpdatedData] = useState(
		employeeStatusInitialData
	);
	const [employeeStatusDataItems, setEmployeeStatusDataItems] = useState(
		employeeStatusInitialData
	);

	const { isPending: isSubmitting, mutate: submitEmployeeStatusFormFields } =
		useMutation({
			mutationFn: EmployeeService.createEmployeeStatus,
			onSuccess: (res: IEmployeeStatus | IServerError | IResponse | any) => {

				if (res.status === 200) {
					setSelectedEmployeeId(res.data.employeeId);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					let path = `/employee/status/${res.data.employeeId}`;
					navigate(path);
					queryClient.invalidateQueries({
						queryKey: [
							"get-employee-status-data-by-employee-id",
							res.data.employeeId,
						],
					});
				} else if (res.status === 201) {
					setSelectedEmployeeId(res.data.employeeId);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					let path = `/employee/status/${res.data.employeeId}`;
					navigate(path);
					queryClient.invalidateQueries({
						queryKey: [
							"get-employee-status-data-by-employee-id",
							res.data.employeeId,
						],
					});
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const formMethods = useForm<any>({
		// resolver: yupResolver(EmployeeStatusSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const { isPending, data: employeeStatusDataByEmployeeId } =
		useGetEmployeeStatusDataByEmployeeId(
			// selectedEmployeeId,
			editRecordId,
			clientId,
			navigateToLogout
		);

	// const { data: employeeStatusLabelsList } = useGetEmployeeStatusDDL(clientId);
	const { data: employeeStatusLabelsList } = useGetEmployeeDDL(clientId);

	const { isPending: isPendingSalaryProfilePermissionsData, data: salaryProfilePermissionsData }: any =
		useGetSalaryProfilePermissionData(
			clientId,
			navigateToLogout,
			selectedEmployeeId,
			null,
		);

	useEffect(() => {

		if (Array.isArray(employeeStatusLabelsList)) {
			setEmployeeStatussList(sortData(employeeStatusLabelsList));
		}
	}, [employeeStatusLabelsList]);

	const onEmployeeSelectionChangeHandler = async (
		selectedItem: any
	): Promise<void> => {

		setSelectedEmployeeId(selectedItem.value);
		setSelectedEmployeeLabel(selectedItem.label);
		setEditRecordId(selectedItem.value);
	};

	const upadtedEmployeeStatusItems = useMemo(() => {
		return (
			employeeStatussList &&
			sortDDLByLabel(employeeStatussList).map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/employee/status/${item.value}`}
						// to={`/employee/status`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => onEmployeeSelectionChangeHandler(item)}
					>
						{item.label}
					</Link>
				),
				// id:item.value
			}))
		);
	}, [employeeStatussList]);

	const employeeStatusDDLItems = [
		{ label: "--", value: null },
		{ label: "Active", value: 100 },
		{ label: "Inactive", value: 300 },
		{ label: "Rehired", value: 400 },
		{ label: "Terminated", value: 500 },
		{ label: "Died", value: 200 },
	];

	const onSubmit = (values: any) => {

		if (selectedEmployeeId) {
			const itemsWithStatusAndDate = employeeStatusUpdatedData.filter(
				(item: any) => item.employeeStatus !== null && item.date !== null
			);
			const isValid = employeeStatusUpdatedData.every((item: any) => {
				const hasDate = item.date !== null;
				const hasStatus = item.employeeStatus !== null;
				return (!hasDate || hasStatus) && (!hasStatus || hasDate);
			});

			if (!isValid) {
				setSnackbarData({
					open: true,
					message: "Required field data missing!",
					severity: "error",
				});
			} else {
				const formattedEmployeeStatusData = itemsWithStatusAndDate.map(
					(item: any) => ({
						...item,
						date:
							item.date && item.date !== "" && item.date !== null
								? formatDate(item.date)
								: null,
					})
				);

				let payload = {
					navigateToLogout: navigateToLogout,
					clientId: clientId,
					// id: employeeStatusDataByEmployeeId && employeeStatusDataByEmployeeId.id,
					id: EmployeeStatusId && EmployeeStatusId,
					employeeId: selectedEmployeeId,
					employeeName: selectedEmployeeLabel,
					// employeeStatus: values.employeeStatus,
					// date: values.date !== null && formatDate(values.date),
					// notes: values.notes,
					employeeStatus: formattedEmployeeStatusData,
				};

				// alert(JSON.stringify(payload, null, 2));
				submitEmployeeStatusFormFields(payload);
			}
		} else {
			setSnackbarData({
				open: true,
				message: "Please Select Employee.",
				severity: "warning",
			});
		}
	};

	useEffect(() => {
		if (employeeStatusDataByEmployeeId && employeeStatusDataByEmployeeId.employeeStatus) {

			// Object.keys(employeeStatusDataByEmployeeId).forEach((fieldName) => {
			// 	const fieldValue = employeeStatusDataByEmployeeId[fieldName];
			// 	formMethods.setValue(fieldName, fieldValue ?? undefined);
			// });
			const formattedEmployeeStatusData =
				employeeStatusDataByEmployeeId.employeeStatus && employeeStatusDataByEmployeeId.employeeStatus.map((item: any) => ({
					...item,
					date: new Date(item.date),
					rowWithRandomId: false
				}));
			setSelectedEmployeeId(employeeStatusDataByEmployeeId.employeeId);
			setSelectedEmployeeLabel(employeeStatusDataByEmployeeId.employeeName);
			setEmployeeStatusId(employeeStatusDataByEmployeeId.id)
			setEmployeeStatusDataItems(formattedEmployeeStatusData);
		} else if (employeeStatusDataByEmployeeId && employeeStatusDataByEmployeeId.message === 'Not Found') {
			setEmployeeStatusId(undefined)
			setEmployeeStatusDataItems(employeeStatusInitialData);
		}
	}, [selectedEmployeeId, employeeStatusDataByEmployeeId]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteEmployeeById } = useMutation({
		mutationFn: EmployeeService.deleteEmployeeStatusById,

		onSuccess: (res: string | IServerError | IResponse | any) => {
			if (
				res === "Employee Status has been deleted successfully"
			) {
				// remove the cache of the Employee fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				// setEmployeeStatusDataItems(employeeStatusInitialData);
				// setEmployeeStatusId(undefined);
				// let path = `/employee/status`;
				// navigate(path);
				queryClient.invalidateQueries({
					queryKey: [
						"get-employee-status-data-by-employee-id",
						selectedEmployeeId,
					],
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteEmployeeField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let Payload = {
				employeeStatusId: EmployeeStatusId,
				clientId: clientId,
				navigateToLogout: navigateToLogout,
			};
			deleteEmployeeById(Payload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = (params: any) => {
		alert(234567890)
		console.log('paramasssssssssssss', params)
		setDialogOpen(true);
		setSingleDelete(true);
		// if (employeeStatusDataByEmployeeId) {
		// setSelectedEmployeeId(employeeStatusDataByEmployeeId.employeeId);
		// setEmployeeStatusId(employeeStatusDataByEmployeeId.id);
		// }
		setEmployeeStatusId(params.id);
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Data has been reset successfully.",
			severity: "success",
		});
		// formMethods.reset();
		setEmployeeStatusDataItems(employeeStatusInitialData);
		let path = `/employee/status`;
		navigate(path);
		formMethods.reset()
		setEditRecordId(undefined)
		setSelectedEmployeeId(undefined);
		setEmployeeStatusId(undefined);
		setSelectedEmployeeLabel("");
	};

	const expandedLabels = ["Employee"];
	const expandedEmployeeStatussetupItem = "Status"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Status" &&
				item.label === expandedEmployeeStatussetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedEmployeeStatussetupItem && "/employee/status",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_STATUS_SETUP_SCREEN_SLUG,
				accountantName: "",
				activityType:
					"activity_type=create&activity_type=updated&activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	return (
		<Grid
		// sx={{ pb: "5rem", "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPending ||
					// isPendingById ||
					isDeleting ||
					isPendingSalaryProfilePermissionsData
				}
				testId="comapny Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteEmployeeField}
				cancelActionHandler={onCloseHandler}
				testId="accountant-confirmation-dialog"
			/>
			<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<Grid
					// item
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
					sx={{ "& .MuiGrid-container": { marginTop: 0 } }}
				>
					<FormProvider {...formMethods}>
						<form onSubmit={formMethods.handleSubmit(onSubmit)}>
							<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
								<Grid
									size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
									sx={{ marginTop: "16px" }}
								>
									<SingleColumnLayout
										children={
											<StandardPanel
												title="Employee Status"
												testId={`employeee-status`}
												showTitle={false}
											>
												{/* <EmployeeStatusInfoSetupFieldsPanel /> */}
												<EmployeeStatusDataTable
													employeeStatusUpdatedData={(data: any) =>
														setEmployeeStatusUpdatedData(data)
													}
													employeeStatusDataItems={employeeStatusDataItems}
													employeeStatusDDLData={employeeStatusDDLItems}
													selectedEmployeeLabel={selectedEmployeeLabel}
													onRowDeleteClicked={(data: any) => onDeleteClicked(data)}
													salaryProfilePermissionsData={salaryProfilePermissionsData && salaryProfilePermissionsData}
												/>
											</StandardPanel>
										}
										toolbar={
											<EmployeeStatusSetupToolbar
												onResetClicked={onResetClicked}
												// onDeleteClicked={onDeleteClicked}
												isSubmitting={false}
												id={EmployeeStatusId}
											/>
										}
										testId="form-layout"
										toolbarPosition="bottom"
										showFullDiaplay={true}
									/>
								</Grid>
								<Grid size={{ xs: 0, sm: 0, md: 1, lg: 1, xl: 1 }}></Grid>
								<Grid
									size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
									sx={{ marginTop: "16px" }}
								>
									<DDLDataTable
										rows={upadtedEmployeeStatusItems}
										// onRowEditClicked={onRowEditClicked}
										// onRowDeleteClicked={onRowDeleteClicked}
										// onRowArchiveClicked={onArchiveClicked}
										showDeleteIcon={false}
										isLoading={false}
										totalRecords={0}
										// initialPageSize={INITIAL_PAGE_SIZE}
										showPaginator={false}
										// rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
										// onRequestParamsChange={onRequestParamsChange}
										tableScrollHeight={"60vh"}
										selectedId={id && employeeStatusDataByEmployeeId && employeeStatusDataByEmployeeId.employeeId ?
											employeeStatusDataByEmployeeId.employeeId : selectedEmployeeId
										}
									/>
								</Grid>
								{/* <Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid> */}
							</Grid>
						</form>
					</FormProvider>
				</Grid>
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"accountant-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
